export const UserAcademicCapIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
      <g clipPath="url(#clip0_10768_3007)">
        <path
          d="M3.5 21.5V20.0285C3.5 19.335 3.74029 18.6629 4.17997 18.1265C4.61966 17.5902 5.23159 17.2228 5.91165 17.0868L8.75765 16.5176C8.99288 16.4705 9.23717 16.5188 9.43677 16.6519V16.6519C10.3439 17.2567 11.4098 17.5794 12.5 17.5794C13.5903 17.5794 14.6562 17.2567 15.5633 16.6519V16.6519C15.7629 16.5188 16.0072 16.4705 16.2424 16.5176L19.0884 17.0868C19.7685 17.2228 20.3804 17.5902 20.8201 18.1266C21.2597 18.6629 21.5 19.335 21.5 20.0285V21.5"
          stroke="#693EB5"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.5 7.89844V10.5001C16.5 11.561 16.0786 12.5784 15.3284 13.3285C14.5783 14.0787 13.5609 14.5001 12.5 14.5001C11.4391 14.5001 10.4217 14.0787 9.67157 13.3285C8.92143 12.5784 8.5 11.561 8.5 10.5001V7.89844"
          stroke="#693EB5"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.6016 13.9062L15.3256 16.8027"
          stroke="#693EB5"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.3998 13.9062L9.67578 16.8026"
          stroke="#693EB5"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.59686 6.95618L11.0514 9.16141C11.5018 9.38413 11.9975 9.5 12.5 9.5C13.0025 9.5 13.4982 9.38413 13.9486 9.16141L18.4031 6.95618C18.5822 6.86865 18.733 6.73263 18.8385 6.56358C18.9441 6.39454 19 6.19927 19 6C19 5.80073 18.9441 5.60545 18.8385 5.43641C18.733 5.26737 18.5822 5.13134 18.4031 5.04382L13.9486 2.83859C13.4982 2.61586 13.0025 2.5 12.5 2.5C11.9975 2.5 11.5018 2.61586 11.0514 2.83859L6.59686 5.04382C6.41784 5.13134 6.26698 5.26737 6.16146 5.43641C6.05594 5.60545 6 5.80073 6 6C6 6.19927 6.05594 6.39454 6.16146 6.56358C6.26698 6.73263 6.41784 6.86865 6.59686 6.95618V6.95618Z"
          stroke="#693EB5"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M19 6.03516V8.63516" stroke="#1C1327" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_10768_3007">
          <rect width="24" height="24" fill="white" transform="translate(0.5 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};
